var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedAlertIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7843 1.27957L0.34311 22.8268C0.118377 23.216 4.15932e-05 23.6574 1.09625e-08 24.1067C-4.15713e-05 24.5561 0.118212 24.9975 0.342873 25.3867C0.567533 25.7758 0.890683 26.099 1.27983 26.3236C1.66899 26.5483 2.11043 26.6666 2.55977 26.6665H27.4402C27.8896 26.6666 28.331 26.5483 28.7202 26.3236C29.1093 26.099 29.4325 25.7758 29.6571 25.3867C29.8818 24.9975 30 24.5561 30 24.1067C30 23.6574 29.8816 23.216 29.6569 22.8268L17.217 1.27957C16.9924 0.890527 16.6693 0.567468 16.2803 0.342858C15.8912 0.118247 15.4499 0 15.0007 0C14.5514 0 14.1101 0.118247 13.7211 0.342858C13.332 0.567468 13.009 0.890527 12.7843 1.27957Z",
    fill: "#EE404C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1619 7.92529H14.8373C14.0383 7.92529 13.3906 8.57301 13.3906 9.37202V16.2871C13.3906 17.0861 14.0383 17.7338 14.8373 17.7338H15.1619C15.9609 17.7338 16.6086 17.0861 16.6086 16.2871V9.37202C16.6086 8.57301 15.9609 7.92529 15.1619 7.92529Z",
    fill: "#FFF7ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9996 23.2182C15.8882 23.2182 16.6086 22.4979 16.6086 21.6092C16.6086 20.7206 15.8882 20.0002 14.9996 20.0002C14.111 20.0002 13.3906 20.7206 13.3906 21.6092C13.3906 22.4979 14.111 23.2182 14.9996 23.2182Z",
    fill: "#FFF7ED"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedAlertIcon);
export default __webpack_public_path__ + "static/media/red-alert-icon.c0796e81d8a0f6bda07bdcb4a2b6bb69.svg";
export { ForwardRef as ReactComponent };